import React, { ChangeEvent, useEffect, useState } from 'react';
import { connect } from "react-redux"
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from "@material-ui/core/Box";
import Button from '@material-ui/core/Button';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { ApplicationState } from "../../redux/reducers";
import { IEvent } from "../../interfaces/IEvent";
import NumberField from "../controls/NumberField";
import { IParametro } from "../../redux/types/parametroActionTypes";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import SubmitButton from "../controls/SubmitButton";
import { ICliente } from "../../entities/catalogos/ICliente";
import { setSolicitudCopia } from "../../redux/actions/solicitudActions";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import useCommonApi from '../../api/useCommonApi';
import swal from 'sweetalert2';
import { MercanciaDatosComplementarios } from '../../entities/solicitudes/MercanciaDatosComplementarios';
import DeleteIcon from '@material-ui/icons/Delete';
import AutocompleteMercanciaControl from '../controls/AutocompleteMercanciasControl';
import { initialMercanciaComplementaria } from '../../redux/reducers/mercanciaDatosComplementariosReducer';
import LoadingDialog from "../controls/LoadingDialog";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { enums } from "../../enums/enums";

interface OwnProps {
    value: MercanciaDatosComplementarios[]
    siguienteTab: (mercanciasDatosComplementarios: MercanciaDatosComplementarios[]) => void;
}

interface StateProps {
    cliente: ICliente
    solicitudCopia: Solicitud
    solicitud: Solicitud
    parametros: IParametro[]
}

interface DispatchProps {
    setSolicitudCopia: typeof setSolicitudCopia
}

type Props = OwnProps & StateProps & DispatchProps

const MercanciaDatosComplementariosLista = ({ value, cliente, siguienteTab, parametros, solicitud }: Props) => {

    useEffect(() => {
        if (!value || value.length === 0) {
            const localData = localStorage.getItem("mercanciasDatos");
            if (localData) {
                setMercancias(JSON.parse(localData));
            }
        } else {
            setMercancias(value);
            localStorage.setItem("mercanciasDatos", JSON.stringify(value));
        }
    }, [value]);
    
    const [mercanciasDatosComplementarios, setMercancias] = useState<MercanciaDatosComplementarios[]>(value);
    const templateDatosComplementarios = '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';

    const [showLoadingPopup, setLoadingPopup] = useState(false);
    const apiSource = useCommonApi();

    const addMercancia = () => {
        const nuevaMercancia = new MercanciaDatosComplementarios(initialMercanciaComplementaria);
        nuevaMercancia.id = mercanciasDatosComplementarios.length === 0 ? 1
            : Math.max(...mercanciasDatosComplementarios.map(m => m.id)) + 1;

        setMercancias([...mercanciasDatosComplementarios, nuevaMercancia]);
    };

    const deleteMercancia = (id: number) => {
        const nuevasMercancias = mercanciasDatosComplementarios.filter(m => m.id !== id);
        setMercancias(nuevasMercancias);
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement> | IEvent, mercancia: MercanciaDatosComplementarios) => {
        const name = event.target.name || "";
        const value = event.target.value;
        mercancia.esFormaValida = true;

        const copiaMercancia = new MercanciaDatosComplementarios(mercancia);
        copiaMercancia.LimpiarCampos(name);

        if (!value || value === "") {
            copiaMercancia[name] = "";
        } else {
            //copiaMercancia[name] = copiaMercancia.esFormaValida ? value : null;
            copiaMercancia[name] = value;
        }

        setMercancias(mercanciasDatosComplementarios.map(m => m.id !== mercancia.id ? m : copiaMercancia));
    };

    const handleSiguienteTab = () => {
        const getClasificacionOrigen = localStorage.getItem('ClasificacionAreaServicioOrigen');
        const getClasificacionDestino = localStorage.getItem('ClasificacionAreaServicioDestino');

        const getCartaPorte = localStorage.getItem('CartaPorte');
        const datosObligatorios = cliente.habilitarDatosCompCartaPorteDetalle;
        const muestraMercanciaComp = cliente.habilitarDatosComplementariosCartaPorte;
        const isValidParamComplementaryData = parametros.find(p => p.id === 
            enums.parametro['AplicaAreaServicioPuertoAeropuertoCartaPorte']);

        if(isValidParamComplementaryData?.valor.toLocaleLowerCase() === "true"){
            if (getClasificacionOrigen === '4' 
                || getClasificacionOrigen === '5' 
                || getClasificacionDestino === '4' 
                || getClasificacionDestino === '5' 
                || getCartaPorte === "true") {
                validarMercanciaDatosComplementarios(true);
                return;
            }
        }

        if(muestraMercanciaComp && !datosObligatorios){
            siguienteTab(mercanciasDatosComplementarios);
            return;
        }

        if(isValidParamComplementaryData?.valor.toLocaleLowerCase() === "true"){
            if (datosObligatorios && !mercanciasDatosComplementarios.length) {
                swal.fire({
                    titleText: traducirMessage(11), // '¡Aviso!',
                    text: traducirMessage(101), // "Favor de completar la sección Detalle Mercancia Datos Complementarios .",
                    type: 'warning',
                });
                return;
            }
        }
    
        let isFormValid = true;
        mercanciasDatosComplementarios.forEach(mercancia => {
            if (!mercancia.cantidad || !mercancia.claveUnidadId || !mercancia.claveProductoId) {
                isFormValid = false;
                swal.fire({
                    titleText: traducirMessage(11),
                    text: traducirMessage(101),
                    type: 'warning',
                });
            }

            mercancia.camposParaValidar?.forEach(s => {
                if (mercancia[s] == null) {
                    isFormValid = false;
                }
                if (s == 'peso' && mercancia[s] == 0) {
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(77), // "El valor del Peso debe ser mayor a 0.",
                        type: 'warning',
                    });
                }
                if (!mercancia['claveFraccionArancelariaId'] && solicitud.distribuidorRemitente && solicitud.distribuidorRemitente.colonia
                    && solicitud.distribuidorRemitente.pais && solicitud.distribuidorRemitente.pais.nombre == 'EU') {
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(45), // "El campo Fracción Arancelaria no puede ir vacio",
                        type: 'warning',
                    });
                }
                if (!mercancia['uuidComprobante'] && solicitud.distribuidorRemitente && solicitud.distribuidorRemitente.colonia
                    && solicitud.distribuidorRemitente.colonia.pais && solicitud.distribuidorRemitente.colonia.pais.nombre == 'EU') {
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(46), // "El campo UUID del Comprobante no puede ir vacio",
                        type: 'warning',
                    });
                }
                if (!mercancia['claveFraccionArancelariaId'] && solicitud.distribuidorDestinatario && solicitud.distribuidorDestinatario.colonia
                    && solicitud.distribuidorDestinatario.colonia.pais && solicitud.distribuidorDestinatario.colonia.pais.nombre == 'EU') {
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(45), // "El campo Fracción Arancelaria no puede ir vacio",
                        type: 'warning',
                    });
                }
                if (!mercancia['uuidComprobante'] && solicitud.distribuidorDestinatario && solicitud.distribuidorDestinatario.colonia
                    && solicitud.distribuidorDestinatario.colonia.pais && solicitud.distribuidorDestinatario.colonia.pais.nombre == 'EU') {
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(46), // "El campo UUID del Comprobante no puede ir vacio",
                        type: 'warning',
                    });
                }

                if (mercancia.claveProducto != null) {
                    if (mercancia.claveProducto.materialPeligroso == "1") {
                        let message = traducirMessage(135), // "HAY PRODUCTOS QUE ESTÁN DEFINIDOS POR EL SAT COMO MATERIALES PELIGROSOS. SI SALTA ESTA SECCIÓN SIN DAR 'SIGUIENTE' LA INFORMACIÓN DE DATOS COMPLEMENTARIOS SE PERDERÁ."
                            isFormValid = false;
                        swal.fire({
                            titleText: traducirMessage(11), // '¡Aviso!',
                            text: message,
                            type: 'warning',
                        });
                    }
                }
            });

            if (!cliente.habilitarDatosCompCartaPorteDetalle) {
                if (!mercancia.cantidad && !mercancia.claveUnidadId && !mercancia.claveProductoId && !mercancia.descripcionMercancia && !mercancia.claveFraccionArancelariaId
                    && !mercancia.uuidComprobante && mercancia.peso == 0) {
                    isFormValid = true;
                }
            }
        });

        if (isFormValid) {
            siguienteTab(mercanciasDatosComplementarios);
        }
    };

    const validarMercanciaDatosComplementarios = (datosObligatorios) => {
        if (datosObligatorios && !mercanciasDatosComplementarios.length) {
            swal.fire({
                titleText: traducirMessage(11), // '¡Aviso!',
                text: traducirMessage(101), // "Favor de completar la sección Detalle Mercancia Datos Complementarios .",
                type: 'warning',
            });
            return;
        }
        
        let valueMSG = 0;
        let isFormValid = true;
        mercanciasDatosComplementarios.forEach(mercancia => {
            if (!mercancia.cantidad || !mercancia.claveUnidadId || !mercancia.claveProductoId) {
                isFormValid = false;
                swal.fire({
                    titleText: traducirMessage(11),
                    text: traducirMessage(101),
                    type: 'warning',
                });
            }
            
            mercancia.camposParaValidar?.forEach(s => {
                if (s == "cantidad" && mercancia[s] == 0) {
                    valueMSG = 311;
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(valueMSG), // "Mensaje configurado",
                        type: 'warning',
                    });
                }

                if (s == "claveUnidadId" && mercancia[s] == "") {
                    valueMSG = 312;
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(valueMSG), // "Mensaje configurado",
                        type: 'warning',
                    });
                }

                if (s == "claveProductoId" && mercancia[s] == "") {
                    valueMSG = 313;
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(valueMSG), // "Mensaje configurado",
                        type: 'warning',
                    });
                }
                
                if (s == "descripcionMercancia" && mercancia[s] == "") {
                    valueMSG = 314;
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(valueMSG), // "Mensaje configurado",
                        type: 'warning',
                    });
                }

                if (s == "peso" && mercancia[s] == 0) {
                    valueMSG = 77;
                    isFormValid = false;
                    swal.fire({
                        titleText: traducirMessage(11), // '¡Aviso!',
                        text: traducirMessage(valueMSG), // "Mensaje configurado",
                        type: 'warning',
                    });
                }
            });
        });

        if (isFormValid) {
            siguienteTab(mercanciasDatosComplementarios);
        }
    }

    const handleClave = (optionSelected, row, campo) => {
        const copiaMercancia = new MercanciaDatosComplementarios(row);
    
        if (optionSelected === null) {
            // Mostrar advertencias según el campo que se deja vacío
            if (campo === 'claveUnidadId') {
                swal.fire({
                    titleText: traducirMessage(11), // '¡Aviso!',
                    text: traducirMessage(121), // "Favor de seleccionar la Cve Unidad.",
                    type: 'warning',
                });
            } else if (campo === 'claveProductoId') {
                swal.fire({
                    titleText: traducirMessage(11), // '¡Aviso!',
                    text: traducirMessage(120), // "Favor de seleccionar la Cve Producto.",
                    type: 'warning',
                });
            } else if (campo === 'claveFraccionArancelariaId') {
                swal.fire({
                    titleText: traducirMessage(11), // '¡Aviso!',
                    text: traducirMessage(125), // "Favor de seleccionar la Fracción Arancelaria.",
                    type: 'warning',
                });
            }
    
            // Limpia el campo correspondiente en copiaMercancia
            copiaMercancia[campo] = '';
            if (campo === 'claveUnidadId') copiaMercancia['claveUnidad'] = null;
            if (campo === 'claveProductoId') copiaMercancia['claveProducto'] = null;
            if (campo === 'claveFraccionArancelariaId') copiaMercancia['claveFraccionArancelaria'] = null;
    
        } else if (optionSelected.clave) {
            // Cuando optionSelected es válido, asigna el valor correspondiente
            copiaMercancia[campo] = optionSelected.clave;
            if (campo === 'claveUnidadId') copiaMercancia['claveUnidad'] = optionSelected;
            if (campo === 'claveProductoId') copiaMercancia['claveProducto'] = optionSelected;
            if (campo === 'claveFraccionArancelariaId') copiaMercancia['claveFraccionArancelaria'] = optionSelected;
    
            // Validaciones adicionales para producto peligroso
            if (campo === 'claveProductoId' && optionSelected.materialPeligroso === "1") {
                let message = traducirMessage(136).replace('#####', `${optionSelected.clave}`);
                swal.fire({
                    titleText: traducirMessage(11), // '¡Aviso!',
                    text: message,
                    type: 'warning',
                });
            }
        }
    
        // Actualiza el estado de mercanciasDatosComplementarios con la copia modificada
        setMercancias(
            mercanciasDatosComplementarios.map(m => m.id !== row.id ? m : copiaMercancia)
        );
    };
    

    const handleUpload = (event) => {
        let file = event.target.files[0];
        const extension = file.name.split(".").pop().toLowerCase();

        if (extension !== "xlsx") {
            const mensaje = traducirMessage(265); // "SOLO SE PERMITEN DOCUMENTOS CON EXTENSIONES TALES COMO: .XLSX";
            swal.fire({ titleText: 'Error!', text: mensaje, type: 'warning' });
            return;
        }

        getBase64(file).then(result => {
            if (result != null) {
                let resultData: any = result;
                let base64String = resultData.split(',');

                let fileInfo = {
                    base64: base64String[1],
                    nombre: file.name,
                    clienteId: cliente.id.toString(),
                    idioma: localStorage.getItem("idioma")
                }
                setLoadingPopup(true);
                processExcel(fileInfo).then(result => {
                    let rows: MercanciaDatosComplementarios[] = mercanciasDatosComplementarios;

                    for (let i = 0; i < result.length; i++) {
                        let row = new MercanciaDatosComplementarios({
                            id: 1,
                            cantidad: result[i].cantidad,
                            claveUnidad: result[i].claveUnidad,
                            claveUnidadId: result[i].claveUnidadId,
                            claveProducto: result[i].claveProducto,
                            claveProductoId: result[i].claveProductoId,
                            claveFraccionArancelaria: result[i].claveFraccionArancelaria,
                            claveFraccionArancelariaId: result[i].claveFraccionArancelariaId,
                            descripcionMercancia: result[i].descripcionMercancia,
                            uuidComprobante: result[i].uuidComprobante,
                            peso: result[i].peso,
                            esFormaValida: false,
                            camposRequeridos: [],
                            camposInvalidos: [],
                        });

                        if (rows.length == 0)
                            row.id = 1;
                        else
                            row.id = Math.max(...rows.map(m => m.id)) + 1;
                        rows.push(row);
                    }

                    setMercancias([])
                    setTimeout(() => {
                        setLoadingPopup(false);
                        setMercancias(rows);
                    }, 100)

                }).catch(err => {
                    setLoadingPopup(false);
                    let message;
                    if (err.data !== undefined)
                        message = err.data.error.code;
                    else
                        message = err.message;
                    swal.fire({
                        titleText: 'Error!',
                        text: message,
                        type: 'warning',
                    });
                })
            }
        });
    }

    const processExcel = async (file) => {
        const result = await apiSource.postAsync<any>("/solicitud-servicio/process-excel", file);
        return result;
    }

    const downloadLayout = () => {
        let row = {
            file64: templateDatosComplementarios,
            tipo: ".xlsx",
            nombre: "LayoutDatosComplementarios.xlsx"
        }
        b64toBlob(row);
    }

    const b64toBlob = (row) => {
        const byteCharacters = atob(row.file64);

        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: row.tipo });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${row.nombre}`;
        link.click();

        return blob;
    }

    const getBase64 = (file) => {
        return new Promise(resolve => {
            let baseURL: any;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    }

    return (<>
        {showLoadingPopup &&
            // Procesando
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
        <ValidatorForm onSubmit={handleSiguienteTab} onError={errors => console.log(errors)}>
            <Box>
                <input
                    accept=".xlsx"
                    style={{ display: 'none' }}
                    id="raised-button-file"
                    onChange={handleUpload}
                    type="file"
                    onClick={(event) => {
                        event.currentTarget.value = ""
                    }} />

                <label htmlFor="raised-button-file">
                    <Button component="span" variant="contained" color="primary" className="pull-right">
                        <input type="file" hidden />
                        {/* SUBIR EXCEL */
                            traducirLabel(286)}
                    </Button>
                </label>
                &nbsp;&nbsp;&nbsp;
                <Button variant="contained" color="primary" onClick={downloadLayout} className="pull-right"
                    style={{ marginRight: "20px" }}>
                    {/* DESCARGAR LAYOUT */
                        traducirLabel(79)}
                </Button>


            </Box>
            <br />
            <TableContainer component={Paper} style={{ marginTop: "10px" }}>
                <Table className="table-xs" size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{ width: "5%" }}>
                                {/* Cantidad */
                                    traducirLabel(29)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "20%" }}>
                                {/* Cve.Unidad */
                                    traducirLabel(37)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "20%" }}>
                                {/* Cve.Producto */
                                    traducirLabel(36)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "15%" }}>
                                {/* Descripción */
                                    traducirLabel(81)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "15%" }}>
                                {/* Fracción Arancelaria */
                                    traducirLabel(144)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "5%" }}>
                                {/* UUID del Comprobante */
                                    traducirLabel(313)}
                            </TableCell>
                            <TableCell align="center" style={{ width: "8%" }}>
                                {/* Peso Kgs */
                                    traducirLabel(231)}
                            </TableCell>
                            <TableCell style={{ padding: 0, width: "4%" }} />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mercanciasDatosComplementarios.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell>
                                    <TextValidator
                                        value={row.cantidad || ""}
                                        name="cantidad"
                                        onChange={(e) => handleChange(e, row)}
                                        validators={['required']}
                                        errorMessages={[traducirLabel(25)]}
                                        title={traducirMessage(298)}
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 2, maxLength: 8 },
                                        }} />
                                </TableCell>
                                <TableCell>
                                    <AutocompleteMercanciaControl name="claveUnidadId"
                                        source={"solicitud-servicio/get-catalogo-clave-unidad/"+cliente.id.toString()}
                                        label={traducirLabel(37)} /*"Clave Unidad"*/
                                        required={true}
                                        onChange={(e, value) => handleClave(
                                            value, row, 'claveUnidadId'
                                        )}
                                        value={row.claveUnidad || ""} />
                                </TableCell>
                                <TableCell>
                                    <AutocompleteMercanciaControl name="claveProductoId"
                                        source={"solicitud-servicio/get-catalogo-clave-producto/"+cliente.id.toString()}
                                        label={traducirLabel(36)} /*"Clave Producto"*/
                                        required={true}
                                        onChange={(e, value) => handleClave(value, row, 'claveProductoId')}
                                        value={row.claveProducto || ""} />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.descripcionMercancia || ""}
                                        name="descripcionMercancia"
                                        onChange={(e) => handleChange(e, row)}
                                        validators={['required']}
                                        errorMessages={[traducirLabel(25)]}
                                        title={traducirMessage(298)}
                                        fullWidth />
                                </TableCell>
                                <TableCell>
                                    <AutocompleteMercanciaControl name="claveFraccionArancelariaId"
                                        source={"solicitud-servicio/get-catalogo-fraccion-arancelaria/"+cliente.id.toString()}
                                        label={traducirLabel(144)} /*"Fracción Arancelaria"*/
                                        onChange={(e, value) => handleClave(value, row, 'claveFraccionArancelariaId')}
                                        required={false}
                                        value={row.claveFraccionArancelaria} />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.uuidComprobante}
                                        name="uuidComprobante"
                                        onChange={(e) => handleChange(e, row)}
                                        errorMessages={[traducirLabel(25)]}
                                        title={traducirMessage(298)}
                                        fullWidth />
                                </TableCell>
                                <TableCell>
                                    <TextValidator
                                        value={row.peso || ""}
                                        name="peso"
                                        onChange={(e) => handleChange(e, row)}
                                        validators={['required']}
                                        errorMessages={[traducirLabel(25)]}
                                        title={traducirMessage(298)}
                                        fullWidth
                                        InputProps={{
                                            inputComponent: NumberField,
                                            inputProps: { precision: 3 },
                                        }} />
                                </TableCell>
                                <TableCell style={{ padding: "0 5px 0 0" }}>
                                    {mercanciasDatosComplementarios.length > 0 &&
                                        <DeleteIcon color="error" style={{ fontSize: "1rem" }} className="pointer"
                                            onClick={() => deleteMercancia(row.id)} />
                                    }
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box mt={2} className="text-right">
                <Button color="primary" size="small" startIcon={<AddCircleIcon />} onClick={addMercancia}>
                    {/* Agregar otra Mercancía */
                    traducirLabel(8)}
                </Button>
            </Box>
            {cliente.habilitarDatosCompCartaPorteDetalle &&
                <SubmitButton />
            }
            {!cliente.habilitarDatosCompCartaPorteDetalle &&
                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Box>
                        <Button onClick={handleSiguienteTab} variant="contained" color="primary">
                            {/* Siguiente */
                            traducirButton(15)}
                        </Button>
                    </Box>
                </Box>
            }
        </ValidatorForm>
    </>);
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    parametros: state.parametros,
    solicitudCopia: state.solicitudCopia,
    solicitud: state.solicitud
});

const mapDispatchToProps = {
    setSolicitudCopia: setSolicitudCopia
};

export default connect(mapStateToProps, mapDispatchToProps)(MercanciaDatosComplementariosLista);
